import { INDIA_USER_ROLE } from 'constants/auth';

export const isIndiaOnlyUser = (roles) => roles.length === 1 && roles.includes(INDIA_USER_ROLE);
